import type { FC } from "react";

import { VatCodeSearchForm } from "src/app/features/VatCode/components/forms/VatCodeSearchForm";
import { VatCodesTable } from "src/app/features/VatCode/components/tables/VatCodesTable";
import type { VatCodeEntity } from "src/app/features/VatCode/types/VatCodeEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const VatCodesPage: FC<NoneOwnProps> = () => {
    const table = <VatCodesTable />;
    const searchForm = <VatCodeSearchForm />;
    const hasAccess = canAccess(ResourceName.VAT_CODES, "canRead");

    return (
        <PageLayout name="vatCodes_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.vatCodes" />
                    <ResourceManager<VatCodeEntity>
                        useDataGroup
                        dataMapperKey="vatCodesTableData"
                        resource={ResourceName.VAT_CODES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
